export default Object.freeze({
	USPS: 'usps',
	UPS: 'ups',
	FedEx: 'fedex',
	DHLExpress: 'dhl_express',
	GlobalPost: 'globalpost',
});
